// Language codes borrowed from https://github.com/shadiabuhilal/rtl-detect/blob/master/lib/rtl-detect.js
var rtlLanguages = ['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'prs', 'ps', 'sd', 'ug', 'ur', 'yi'];
var languages = {
  en: {
    name: 'English',
    nativeName: 'English',
    value: 'en'
  },
  zh: {
    name: 'Chinese (Si.)',
    nativeName: '简体中文',
    value: 'zh'
  },
  zh_HANT: {
    name: 'Chinese (Tr.)',
    nativeName: '繁體中文',
    value: 'zh_HANT'
  },
  fr: {
    name: 'French',
    nativeName: 'Français',
    value: 'fr'
  },
  de: {
    name: 'German',
    nativeName: 'Deutsch',
    value: 'de'
  },
  hi: {
    name: 'Hindi',
    nativeName: 'हिंदी',
    value: 'hi'
  },
  id: {
    name: 'Indonesian',
    nativeName: 'Indonesia',
    value: 'id'
  },
  it: {
    name: 'Italian',
    nativeName: 'Italiano',
    value: 'it'
  },
  ja: {
    name: 'Japanese',
    nativeName: '日本語',
    value: 'ja'
  },
  ko: {
    name: 'Korean',
    nativeName: '한국어',
    value: 'ko'
  },
  pl: {
    name: 'Polish',
    nativeName: 'polski',
    value: 'pl'
  },
  pt: {
    name: 'Portuguese (Br.)',
    nativeName: 'português (br.)',
    value: 'pt'
  },
  ru: {
    name: 'Russian',
    nativeName: 'Русский',
    value: 'ru'
  },
  es: {
    name: 'Spanish',
    nativeName: 'Español',
    value: 'es'
  },
  th: {
    name: 'Thai',
    nativeName: 'ไทย',
    value: 'th'
  },
  tr: {
    name: 'Turkish',
    nativeName: 'Türkçe',
    value: 'tr'
  },
  vi: {
    name: 'Vietnamese',
    nativeName: 'Việt',
    value: 'vi'
  }
};
var defaultLanguage = languages.en;

export { defaultLanguage, languages, rtlLanguages };
//# sourceMappingURL=index.js.map
